import { render } from "./CalendarEventAttendeeSelectionList.vue?vue&type=template&id=3596d503&scoped=true"
import script from "./CalendarEventAttendeeSelectionList.vue?vue&type=script&lang=ts"
export * from "./CalendarEventAttendeeSelectionList.vue?vue&type=script&lang=ts"

import "./CalendarEventAttendeeSelectionList.vue?vue&type=style&index=0&id=3596d503&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3596d503"

export default script